const getters = {
  challengeId: function(state) {
    return state.challenge._id
  },
}

export default getters
